// import constants from "../constants";

import httpService from "./httpService";

export default {

  getCurrentSessionToken() {
    return httpService.get("/fcm");
  },

  saveDeviceToken(form) {
    return httpService.post("/fcm", form);
  },

  // clearSessionToken(fcmToken, userId) {
  //   // let params = {fcmToken: fcmToken, userId: userId};
  //   return httpService.post(`/fcm/removeByToken?fcmToken=${fcmToken}&userId=${userId}`, null, {
  //     headers: {
  //       'cookie': document.cookie
  //     },
  //   });
  // },

  clearSessionToken(fcmToken) {
    const form = {fcmToken: fcmToken};
    return httpService.post("/fcm/removeByTokenV2", form);
  },

  getFromLocalStorage() {
    return this.get('device-token');
  },

  saveToLocalStorage(deviceToken) {
    return Promise.resolve(
      this.store('device-token', deviceToken)
    );
  },

  removeDeviceToken() {
    return localStorage.removeItem('device-token');
  },

  store(key, value) {
    value == null || value === undefined ? localStorage.removeItem(key) : localStorage.setItem(key, value);
  },

  get(key) {
    return localStorage.getItem(key);
  },

  remove(key) {
    return localStorage.removeItem(key);
  },

};



// WEBPACK FOOTER //
// ./src/services/fcmService.js